import { I18n } from '@calendly/i18n';
import { HeadingText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { Layout, LayoutItem } from 'components/layout';
import { Status } from '../../shared/status';
import { DurationWithLocation } from '../duration_with_location';
import { Menu } from '../menu';
const Container = props => <Layout direction="column" gap="8" paddingX="24" {...props} />;
const Item = props => <LayoutItem paddingLeft="24" {...props} />;
const TitleContainer = props => <Layout grow {...props} />;
const markerContainerCss = "m1b8149y";
const MarkerContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(markerContainerCss, props.className)} />;
});
const markerCss = "m169bmmf";
const Marker = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    color,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const style = {
    backgroundColor: color
  };
  return <Component ref={ref} {...restProps} style={style} className={classNames(markerCss, props.className)} />;
});
const subheaderCss = "sqk1osx";
const Subheader = forwardRef((props, ref) => {
  const as = 'div';
  const variant = 'eyebrow';
  const color = colorTextSecondary;
  return <HeadingText ref={ref} {...props} as={as} variant={variant} color={color} className={classNames(subheaderCss, props.className)} />;
});
const TitleRow = ({
  poll
}) => <Layout>
    <MarkerContainer>
      <Marker color={poll.color} />
    </MarkerContainer>
    <TitleContainer>
      <HeadingText level={2}>
        {poll.name}
      </HeadingText>
    </TitleContainer>
    <Menu poll={poll} />
  </Layout>;
export const Header = ({
  poll
}) => {
  const {
    status,
    collective
  } = poll;
  return <Container>
      <div>
        <Item>
          <Subheader>
            {collective ? I18n.t('publisher.labels.collective_meeting_poll') : I18n.t('publisher.labels.meeting_poll')}
          </Subheader>
        </Item>
        <TitleRow poll={poll} />
        <Item>
          <DurationWithLocation poll={poll} />
        </Item>
      </div>
      <Item>
        <Status status={status} />
      </Item>
    </Container>;
};

require("./header.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./header.js");